import {Injectable} from '@angular/core';
import {Observable} from "rxjs/internal/Observable";
import {CommonHttpService, optimistic} from "./common-http.service";
import {Article} from "../model/catalog/article.model";
import {
  AccessoryItem,
  Backside,
  BacksideQuery,
  CareItem,
  Color,
  ColorQuery,
  FeatureDecimalFormat,
  Lens,
  LensDetails,
  LensQuery,
  Material,
  MaterialQuery, Preload
} from "../model/catalog/catalog.model";
import {AuthHttpService} from "./auth-http.service";
import {AppResponse} from "./app-response.model";

@Injectable({
  providedIn: 'root'
})
export class CatalogApiService {

  constructor(private http: CommonHttpService, private authHttp: AuthHttpService) {
  }

  getSampleArticles(): Observable<Array<Article>> {
    return this.http.get<Array<Article>>("/articles/sample").pipe(optimistic);
  }

  searchMaterials(query: MaterialQuery): Observable<Array<Material>> {
    return this.authHttp.post<Array<Material>>("/materials/search", query).pipe(optimistic);
  }

  searchBacksides(query: BacksideQuery): Observable<Array<Backside>> {
    return this.authHttp.post<Array<Backside>>("/back-sides/search", query).pipe(optimistic);
  }

  searchLenses(query: LensQuery): Observable<Array<Lens>> {
    return this.authHttp.post<Array<Lens>>("/lenses/search", query).pipe(optimistic);
  }

  searchColors(query: ColorQuery): Observable<Array<Color>> {
    return this.authHttp.post<Array<Color>>("/colors/search", query).pipe(optimistic);
  }

  getLensDetails(lensId: number): Observable<LensDetails> {
    return this.authHttp.get<LensDetails>("/lenses/" + lensId).pipe(optimistic);
  }

  getAccessories(): Observable<Array<AccessoryItem>> {
    return this.authHttp.get<Array<AccessoryItem>>("/accessories").pipe(optimistic);
  }

  getCareItems(): Observable<Array<CareItem>> {
    return this.authHttp.get<Array<CareItem>>("/care-items").pipe(optimistic);
  }

  switchOrdering(id: number): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/ordering/" + id, "Switch Electronic Ordering for article: " + id);
  }

  getFeatureDecimalFormats(): Observable<Array<FeatureDecimalFormat>> {
    return this.authHttp.get<Array<FeatureDecimalFormat>>("/decimal-formats").pipe(optimistic);
  }

  addCatalog(catalog: string): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/catalogs", catalog);
  }

  preload(): Observable<Preload> {
    return this.authHttp.get<Preload>("/preload").pipe(optimistic);
  }
}
